import { render, staticRenderFns } from "./AddEditStockPrices.vue?vue&type=template&id=3b193268&scoped=true&"
import script from "./AddEditStockPrices.vue?vue&type=script&lang=js&"
export * from "./AddEditStockPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b193268",
  null
  
)

export default component.exports